'use strict';

require('dibs-gas');

var serverVars = require('server-vars');
var _gas = require('./gas');
var gtmDataLayer = require('./gtmDataLayer');
var parseurl = require('parseurl');
var jsCookie = require('js-cookie');
var Deferred = require('simply-deferred').Deferred;
var merge = require('lodash.merge');

var undefined = void(0);
var root = typeof window === 'undefined' ? global : window;
var location = root.document ? root.document.location : {hostname: ''};
var cookieSettings = {
    path : '/',
    domain : location.hostname.split('.').slice(-2).join('.')
};

function isEmpty(value) {
    return value ? !Object.keys(value).length : true;
}

function pick(data, dataKeys) {
    var newObject = {};
    Object.keys(data).forEach(function (key) {
        if (dataKeys.indexOf(key) !== -1) {
            newObject[key] = data[key];
        }
    });
    return newObject;
}

function omit(data, dataKeys) {
    var newObject = {};
    Object.keys(data).forEach(function (key) {
        if (dataKeys.indexOf(key) === -1) {
            newObject[key] = data[key];
        }
    });
    return newObject;
}

/*
 *
 * SETUP 1STDIBS-SPECIFIC TRACKING HERE, DON'T PUT OUTSIDE DEPENDENCIES IN GAS.SETUP
 *
 */

// serverVars is undefined on legacy pages
// TODO: May have to do this for data layers
serverVars = serverVars || {};
var serverVarsTracking = serverVars.tracking;
var customVarLoginStr = 'login='; // used for tracking.getLoggedInStatus
var tracking = {};
var defaults = {
    'opt_label': undefined,
    'opt_value': undefined,
    'opt_noninteraction': undefined
};

// provide backward-compatibility for the legacy
// dibs.tracking.customVars array
if (serverVarsTracking) {
    tracking.customVars = serverVarsTracking.customVars || [];
}

// Boolean flags and methods used to ensure events are fired to Google Tag Manager in the correct order
// (see startTrackingEvents method description)
var gtmInitialInfoFired     = false;
var gtmInitialPageViewFired = false;
var startTrackingEvents;

var ecomParseUrl;
var ecomGetProducts;
var mergeAdditionalData;
var useShippingStatusData;
var shippingStatusDfd       = Deferred();
var gtmEventQueue           = [];
var gtmPageInfo             = serverVars.get('tracking.initialDataLayerInfo');
var gtmUserAttributeKeys    = [
    'loginStatus',
    'registrationStatus',
    'userID',
    'guestID',
    'userEmail',
    'userEmailAddress',
    'emailToken',
    'userZip',
    'defaultCurrency',
    'firstSessionDate',
    'contactDealerStatus',
    'buyerStatus',
    'firstPurchaseDate',
    'firstPurchasePrice',
    'tradeStatus',
    'customerType'
];
var gtmContentGroupKeys     = ['pageType', 'pageSubType', 'pageLevel', 'pageSection', 'pageCategory'];
var comCustomDimensionMap = {
    dimension1  : 'timePeriod',
    dimension2  : 'creator',
    dimension8  : 'onSale',
    dimension9  : 'newListing',
    dimension11 : 'dealerName',
    dimension12 : 'dealerID',
    dimension13 : 'dealerLocation',
    dimension20 : 'itemPostingLocation',
    dimension37 : 'purchaseStatus',
    dimension38 : 'askingPrice',
    dimension76 : 'priceType'
};

/**
 * For Google Tag Manager to work properly the order in which data is added to the dataLayer is important
 *  1. initial page data/user info
 *  2. initial page view event
 *  3. any ga events fired on the page
 * This is a private function which is called by either tracking.trackPageView or tracking.addUserAttributes and
 * controls this flow of how events are fired.
 * @private
 */
startTrackingEvents = function () {
    // need to check that we aren't already tracking events so that forEach call
    // doesn't accidentally put us in an infinite loop
    if (gtmEventQueue === gtmDataLayer) {
        return;
    }

    // add each of the events in the queue to the gtmDataLayer (in fifo order)
    gtmEventQueue.forEach(function (event, index) {
        gtmDataLayer.push(event);
    });

    // change reference
    gtmEventQueue = gtmDataLayer;
};

/**
 * helper method used to parse a pdp url for an item's category level (L1/L2/L3), name and id
 * @param url
 * @returns {*}
 */
ecomParseUrl = function (url) {
    var pathArr;
    if (typeof url !== 'string') {
        return {};
    }
    // given a pdp url of the form -->
    //      https://www.1stdibs.com/{L1}/{l2}/{L3}/{product name}/id-{item pk}/?{random params}
    // set pathArr to
    //      [path, {L1/L2/L3}, {L1}, {L2}, {L3}, {product name}, {item pk}]
    pathArr = /^\/(?:([^\/]*)\/([^\/]*)(?:(?:\/([^\/]*)(?:\/([^\/]*)))|(?:\/([^\/]*))?))\/id-([^/]+)\/?$/i.exec(parseurl({url: url}).pathname);
    if (isEmpty(pathArr)) {
        return {};
    }
    // grab the item id, the product name and the uri substring for the categories
    return {
        category: [pathArr[1], pathArr[2], pathArr[3]].filter(function (elem) {
            return !!elem;
        }).join('/'),  // {L1/L2/L3}
        name: (pathArr[4] || pathArr[5] || '').split('-').join(' '),
        id: pathArr[6]
    };
};

/**
 * helper method (used in ecommerceProduct) that takes the trackObj products array and returns a product array
 * formatted for the GTM tracking object.
 * @param prodArr
 * @returns {Array}
 */
ecomGetProducts = function (productArray) {
    var outArr = [];
    var productData;
    if (productArray !== undefined && productArray.length) {
        productArray.forEach(function (product, index) {
            productData = merge(ecomParseUrl(product.url), product);
            productData = mergeAdditionalData(productData, product);
            productData = omit(productData, ['url', 'additional']);
            outArr.push(productData);
        });
    }
    return outArr;
};

/**
 * this helper function is used in tracking.trackPageView, tracking.trackSocial, and tracking.trackEvent
 * to merge additional data into the trackObject that is pushed to the dataLayer
 * @param gtmData
 * @param trackObj
 */
mergeAdditionalData = function (gtmData, trackObj) {
    var additionalData = trackObj ? trackObj.additional : {};
    return merge({}, gtmData, additionalData);
};

/**
 * Sets flag to ensure we wait for shipping status data to resolve before we track it
 */
tracking.setupShippingStatusTracking = function () {
    useShippingStatusData = true;
};

/**
 * Resolves the shippingStatusDfd singleton with the passed data
 */
tracking.resolveShippingStatusDfdWith = function (data) {
    shippingStatusDfd.resolve(data);
};

/**
 * check for this value at run time instead of setting it once at run time
 * @returns {boolean}
 */
tracking.isGaAllowed = function () {
    // phpstorm says this condition can be simplified
    // but it makes it less readable IMO
    // return !(serverVars.settings && serverVars.settings.allowGa === false);
    // is what it like instead
    if (serverVars.settings && serverVars.settings.allowGa === false) {
        return false;
    }
    return true;
};

/**
 * returns the logged in status of the user
 * @param {boolean} status Whether the user is logged in or not
 * @returns {string}
 */
tracking.getLoggedInStatus = function (status) {
    if (typeof status !== 'boolean') {
        return customVarLoginStr + 'n';
    }
    return customVarLoginStr + (status ? 'y' : 'n');
};

/**
 * pushes userAttributes into the dataLayer (along with the gtmPageInfo)
 * @param trackObj
 */
tracking.addUserAttributes = function addUserAttributes(trackObj) {
    var gtmUserAttributes;
    if (!isEmpty(trackObj) && !gtmInitialInfoFired) {
        // filters out invalid userAttribute keys
        gtmUserAttributes = pick(trackObj, gtmUserAttributeKeys);

        // Once the shipping status data is available, proceed setting attributes to the gtmDataLayer
        // If not using shipping status data, go forward and resolve the deferred object
        if (!useShippingStatusData) {
            shippingStatusDfd.resolve();
        }
        shippingStatusDfd.done(function (userQuoteData) {

            // pushing the initial dataLayerInfo directly to the dataLayer
            gtmDataLayer.push(merge(gtmUserAttributes, gtmPageInfo, userQuoteData));
            gtmInitialInfoFired = true;

            // if the pageView has not been fired then we want to wait for it to be fired to start tracking events
            if (gtmInitialPageViewFired) {
                startTrackingEvents();
            }
        });

    }
};

tracking.resetGTMPageView = function resetGTMPageView() {
    gtmInitialPageViewFired = false;
    gtmEventQueue           = [];
};

/**
 * resets the google tag manager tracking by setting all the flags back to false, recreating the event queue
 * ** FOR TESTING **
 */
tracking.resetGtmTracking = function resetGtmTracking() {
    gtmInitialInfoFired     = false;
    gtmPageInfo             = serverVars.get('tracking.initialDataLayerInfo');
    this.resetGTMPageView();
};

/**
 * when tracking object is not known in client, there has to be a way
 * around setting it without using server-vars.
 */
tracking.setGtmPageInfo = function setGtmPageInfo(trackingObj) {
    gtmPageInfo = trackingObj;
};

/**
 * sets te google tag manager tracking flags to true and calls startTrackingEvents()
 * ** FOR TESTING **
 */
tracking.setGtmFlagsTrue = function setGtmFlagsTrue() {
    gtmInitialInfoFired     = true;
    gtmInitialPageViewFired = true;
    startTrackingEvents();
};

/**
 * The main page view tracking call
 * @param {string || object} trackObj       Can either be the literal url or an object with a url key
 *                                          (can also be undefined in which case GTM will internally grab
 *                                          the url from the page)
 * @param {string} trackObj.url
 * @param {object} [trackObj.additional]    An object with any additional key/value pairs to pass to GTM
 *                                          added to gtmData in mergeAdditionalData(gtmData, trackObj)
 */
tracking.trackPageview = function trackPageview(trackObj) {
    var gtmData;

    // this is necessary for stale logins on checkout
    // so that the page view tracking doesn't fire twice
    if (this.isGaAllowed()) {

        gtmData = {
            'event'         : 'e_ga_pageview',
            'opt_pageURL'   : (typeof trackObj === 'object') ? trackObj.url : trackObj
        };
        gtmData = mergeAdditionalData(gtmData, trackObj);
        gtmData.opt_pageURL = gtmData.opt_pageURL || undefined; // eslint-disable-line

        // If this is not the initial page view then just push it like a regular event
        if (gtmInitialPageViewFired) {
            gtmEventQueue.push(gtmData);

            // If it is the initial page view then add it to the beginning of the queue, switch flag
        } else {
            gtmEventQueue.unshift(gtmData);
            gtmInitialPageViewFired = true;

            // if the initial dataLayer info has not been added then we want to wait to start tracking events
            if (gtmInitialInfoFired) {
                startTrackingEvents();
            }
        }
    }
};

// TODO: REMOVE CUSTOM VARIABLE STUFF BECAUSE GA IS NO LONGER USING CUSTOM VARIABLES IN UNIVERSAL ANALYTICS
/**
 * set a custom var for google analytics.  Having one spot to set this allows for better control of determining
 * when to fire and when not to fire these events
 * FINDING-2644 - do not allow browser "previews" from firing tracking
 * https://developers.google.com/analytics/devguides/collection/gajs/gaTrackingCustomVariables
 *
 * @param {object}  trackObj        The tracking object used by google analytics
 * @param {int}     trackObj.slot   The slot number for the custom var. Defaults to 1
 * @param {string}  trackObj.name   The 2nd-level name for your online content categories
 * @param {string}  trackObj.value  The value to set trackObj.name to
 * @param {int}     trackObj.scope  The scope of the page level based on the GA docs (1, 2 or 3).  Defaults to 1
 */
tracking.setCustomVar = function setCustomVar(trackObj) {
    if (this.isGaAllowed() && !isEmpty(trackObj)) {
        _gas.push([
            '_setCustomVar',
            trackObj.slot || 1,
            trackObj.name || 'No Page Name',
            trackObj.value || 'No Page Value',
            trackObj.scope || 1
        ]);
        this.setCustomVarLocal(trackObj);
    }
};

/**
 * Sets the tracking object to a 'local' cookie representing the
 * current state of custom vars in GA
 * @param {object} trackingObj The tracking object used by google analytics
 */
tracking.setCustomVarLocal = function setCustomVarLocal(trackingObj) {
    var localCustomVars;
    jsCookie.json = true;
    localCustomVars = jsCookie.getJSON('lcv') || {};
    localCustomVars[trackingObj.slot] = trackingObj;
    jsCookie.set('lcv', localCustomVars, cookieSettings);
    delete jsCookie.json;
};

/**
 * Gets the "local" copy of the GA custom vars for the given slot
 * @param {int}     slotNumber
 *
 * @returns {object}
 */
tracking.getCustomVar = function getCustomVar(slotNumber) {
    var localCustomVars;

    jsCookie.json = true;
    localCustomVars = jsCookie.get('lcv') || {};
    delete jsCookie.json;

    return localCustomVars[slotNumber];
};

/**
 * Event tracking using Google Tag Manager
 * @param {object} trackObj
 * @param {string} trackObj.category    The tracking category - a way to group objects to track
 * @param {string} trackObj.action      The tracking action - typically the type of event or interaction
 * @param {string} [trackObj.label]     The tracking label - additional dimension to use for tracking
 * @param {number} [trackObj.value]     The tracking value
 * @param {boolean} [trackObj.noninteraction] Affects bounce rate (must be explicitly passed in to trigger a page view)
 *                                            - `true` (default) will not count as another page view which will mean if a user visits one page, interacts, and leaves, a bounce will be triggered (expected)
 *                                            - `false` will essentially treat the interaction as a page view and not trigger a bounce if the user leaves the page
 * @param {object} [trackObj.additional] An object with any additional key/value pairs to pass to GTM
 */
tracking.trackEvent = function trackEvent(trackObj) {
    var gtmData;
    if (!isEmpty(trackObj)) {
        trackObj.value          = (trackObj.value !== undefined) ? trackObj.value : 0;
        trackObj.noninteraction = (trackObj.noninteraction !== undefined) ? trackObj.noninteraction : 1;

        gtmData = {
            'event'         : 'e_ga_event',
            'category'      : (trackObj.category || 'no category').toLowerCase(),
            'action'        : trackObj.action || 'no action',
            'label'         : trackObj.label || 'none',
            'value'         : trackObj.value,
            'noninteraction': trackObj.noninteraction
        };
        gtmData = mergeAdditionalData(gtmData, trackObj);

        gtmEventQueue.push(gtmData);
    }
};
/**
 * Form Error tracking using Google Tag Manager
 * @param trackObj
 */
tracking.trackFormError = function (trackObj) {
    var gtmData;
    if (!isEmpty(trackObj)) {
        trackObj.value          = (trackObj.value !== undefined) ? trackObj.value : 0;
        trackObj.noninteraction = (trackObj.noninteraction !== undefined) ? trackObj.noninteraction : 1;

        gtmData = {
            'event'         : 'e_form_error',
            'category'      : 'form error',
            'action'        : trackObj.action || 'no action',
            'label'         : trackObj.label || 'none',
            'value'         : trackObj.value,
            'noninteraction': trackObj.noninteraction
        };
        gtmData = mergeAdditionalData(gtmData, trackObj);

        gtmEventQueue.push(gtmData);
    }
};

/**
 * Social tracking using Google Tag Manager
 * @param {object} trackObj
 * @param {string} trackObj.name            The social network name
 * @param {string} trackObj.event           The type of event it is firing
 * @param {object} [trackObj.additional]    An object with any additional key/value pairs to pass to GTM
 */
tracking.trackSocial = function trackSocial(trackObj) {
    var gtmData;

    if (trackObj.name && trackObj.event) {
        gtmData = {
            'event'         : 'e_ga_social',
            'network'       : trackObj.name,
            'socialAction'  : trackObj.event,
            'opt_target'    : trackObj.opt_target   || undefined,
            'opt_pagePath'  : trackObj.opt_pagePath || undefined
        };
        gtmData = mergeAdditionalData(gtmData, trackObj);

        gtmEventQueue.push(gtmData);
    }
};

/**
 * Ecommerce Tracking used in Google Tag Manager
 * @param {object} trackObj
 * @param {string} trackObj.type            - productImpression/productClick/productDetail
 * @param {Array}  trackObj.products        - an array of objects, each containing one product's info
 *                                              {   url     : product url,
 *                                                  brand   : dealer id,
 *                                                  price   : USD price     ... }
 * @param {object} [trackObj.actionField]   - an object containing additional information specific to each tracking type
 *                                          { list : list,
 *                                            step : 1      ... }
 */
tracking.trackEcommerce = function ecommerceProduct(trackObj) {
    var products;
    var ecommerce = {};

    if (!isEmpty(trackObj) && trackObj.type) {
        products = ecomGetProducts(trackObj.products);
        switch (trackObj.type) {
            case 'productImpression' :
                if (products.length) {
                    ecommerce.impressions = products;
                } else {
                    ecommerce = undefined;
                }
                break;
            case 'productClick':
                if (trackObj.actionField && trackObj.actionField.list && products.length) {
                    ecommerce.click = {
                        'actionField' : { list : trackObj.actionField.list },
                        'products'    : products
                    };
                }
                break;
            case 'productDetail':
                if (products.length) {
                    ecommerce.detail = { 'products' : products };
                } else {
                    ecommerce = undefined;
                }
                break;
            case 'addToCart':
                if (products.length) {
                    ecommerce.add = { 'products'  : products };
                }
                break;
            case 'checkout':
                if (trackObj.actionField && trackObj.actionField.step && products.length) {
                    ecommerce.checkout = {
                        'actionField'   : { 'step' : trackObj.actionField.step },
                        'products'      : products
                    };
                    if (trackObj.option) {
                        ecommerce.checkout.option = trackObj.option;
                    }
                }
                break;
            case 'promotionImpression' :
                if (trackObj.promotions && trackObj.promotions.length) {
                    ecommerce.promoView = { promotions : trackObj.promotions };
                }
                break;
            case 'promoClick' :
                if (trackObj.promotions && trackObj.promotions.length) {
                    ecommerce.promoClick = { promotions : trackObj.promotions };
                }
                break;
        }
        // FINDING-8606 allow ecommerce === undefined because when ecommerce
        // is undefined it removes the event from the data layer. Which stops it from
        // being tracked on every vpv
        if (!isEmpty(ecommerce) || ecommerce === undefined) {
            gtmEventQueue.push({
                'event'     : 'ecommerce_' + trackObj.type,
                'ecommerce' : ecommerce
            });
        }
    }
};

/**
 * Maps the data values to the appropriate custom dimension indexes used by google analytics
 * (e.g. returns object { dimension1 : '1900s', dimension38 : '1000' } which ga will then map on their end
 * to 'timePeriod' and 'askingPrice' respectively).
 * @param   {object} data
 * @param   {array}  [dataKeys]         optional parameter to specify which specific keys in the
 *                                      data param should be tracked.
 * @returns {object} customDimensions
 */
tracking.getCustomDimensions = function (data, dataKeys) {
    var customDimensions = {};

    if (data !== undefined) {
        // removes any key/values that are not wanted
        data = dataKeys ? pick(data, dataKeys) : data;

        // returns an object with the data object values associated with the correct dimension key
        var keys = Object.keys(comCustomDimensionMap);
        keys.forEach(function (key) {
            if (data[comCustomDimensionMap[key]] !== undefined) {
                customDimensions[key] = data[comCustomDimensionMap[key]];
            }
        });
    }

    return customDimensions;
};

/**
 * Ecommerce tracking function (specifically for tracking transactions)
 * This need to be sent to Google before userAttributes, gtmPageInfo or pageview is fired.
 * @param {object} trackObj
 * @param {array} trackObj.products
 * @param {object} trackObj.actionField
 */
tracking.trackEcommercePurchase = function (trackObj) {
    var products = ecomGetProducts(trackObj.products);
    var ecommerce = {};

    if (trackObj.actionField && products.length) {
        ecommerce.purchase = {
            'actionField'   : trackObj.actionField,
            'products'      : products
        };
    }

    if (!isEmpty(ecommerce)) {
        gtmDataLayer.push({
            'event'     : 'ecommerce_' + trackObj.type,
            'ecommerce' : ecommerce
        });
    }
};

tracking.addGTMMessage = function (message) {
    gtmDataLayer.push(message);
};

/**
 * Grabs a page's current content groupings
 * (This is needed when modals are opened and closed so that events are attributed to the correct page without firing
 * pageviews that will inflate GA's page hit numbers)
 * @return {object} contentGroupings
 */
tracking.getOriginContentGroupings = function () {
    return pick(gtmPageInfo || {}, gtmContentGroupKeys);
};

tracking.fireDummyEvent = function () {
    //we need to fire a dummy trackEvent in order to send the custom variable to the GA server
    //http://stackoverflow.com/questions/10038450/setting-a-custom-variable-in-google-analytics-after-trackpageview-is-called
    this.trackEvent({
        category: 'Dummy Event',
        action: 'Dummy Event',
        label: ''
    });
};

tracking.setDefault = function setDefault(what, toWhat) {
    var i;
    if (what && typeof what === 'object') {
        for (i in what) {
            if (what.hasOwnProperty(i)) {
                this.setDefault(i, what[i]);
            }
        }
    }
    what = '' + what;
    if (defaults.hasOwnProperty(what)) {
        defaults[what] = toWhat;
    }
};

tracking.clearDefault = function (what) {
    return this.setDefault(what, undefined);
};

module.exports = tracking;



//////////////////
// WEBPACK FOOTER
// ./~/dibs-tracking/tracking.js
// module id = 27
// module chunks = 62